import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DialogComponent } from '../../dialog.component';

export class DialogFormCustomValidator {
  static macthValue(string: string): ValidatorFn {
    return (control:AbstractControl): { [key: string]: boolean } | null => {
        const value: string = control.value;
        if (!value) {
          return {macthValue:true};
        } 
        
        const macthValue = value == string;
        return !macthValue ? {macthValue:true}: null;
    }
  }
}
@Component({
  selector: 'app-dialog-confirm-element-deletion',
  templateUrl: './dialog-confirm-element-deletion.component.html',
  styleUrls: ['./dialog-confirm-element-deletion.component.scss']
})
export class DialogConfirmElementDeletionComponent implements OnInit {

  public formulario: UntypedFormGroup;
  public titleButton: string;

  public data: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dataComponent: DialogComponent) 
  {
      this.formulario = this.formBuilder.group({
        element_name: [null, DialogFormCustomValidator.macthValue(dataComponent.data.element?.name)],
      });
  }

  ngOnInit(): void {
  }

  // convenience getter for easy access to form fields
  get f() { return this.formulario.controls; }

}
